import React from 'react';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
//import Table from "react-bootstrap/Table";


const FutureFixtureValidationPopupModal = ((props) => {

    const { show, onHide } = props;

    return <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        centered
    >
        <Modal.Header>
            <Modal.Title>
                <h4>
                Future Fixture - Unable to Select Players until Fixture date or Teams are added Manually
                </h4>
            </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
            <Button variant="primary" onClick={onHide}>Ok</Button>
        </Modal.Footer>
    </Modal>;
});

export default FutureFixtureValidationPopupModal;